export const NULL_MOVE = '0x0000000000000000000000000000000000000000000000000000000000000000';
